<template>
  <ol class="c-profile-menu listless">
    <slot></slot>
  </ol>
</template>

<script>
export default {};
</script>

<style lang="scss">
.c-profile-menu {
  li {
    padding: 0;
    border-bottom: 1px solid $colour-nhs-pale-grey;
  }
}
</style>